// extracted by mini-css-extract-plugin
export default {"cls1":"Reader-cls1_bH2","cls2":"Reader-cls2_urE Reader-cls1_bH2"};